import axios from "axios";



export const fetchAllInvoices = async (token) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_API_URL+'/get-invoices', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
  };
  
 
  export const fetchInvoice = async (token, id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_API_URL+'/get-invoice-detail/'+id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
  };



  export const generateInvoice = async (id, token) => {
    try {
      const response = await axios.post(process.env.REACT_APP_BASE_API_URL+'/generate-invoice', {ticket_id: id}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
  };